module.exports = __webpack_public_path__ + "img/RaspberryPi_3BPlus.a5f949fc.svg";